// Color scheme based on dushanbe24.ru brand colors
// Primary: #ED1B23 (Red), Secondary: #0E89C5 (Blue)
const palette = {
  // ─── Core Brand (Red — dushanbe24.ru primary) ──────────────────────────────
  primary: "#ED1B23",
  primaryLight: "#FF3344",
  primaryDark: "#CF1C2A",
  primarySubtle: "#FEECEC",
  primaryBorder: "#FBBBBC",
  primaryAlpha: "rgba(237, 27, 35, 0.04)",
  primaryShadowHover: "rgba(237, 27, 35, 0.25)",

  // ─── Secondary (Blue — dushanbe24.ru secondary) ────────────────────────────
  secondary: "#0E89C5",
  secondaryLight: "#2B9FD4",
  secondaryDark: "#0A6FA0",
  secondarySubtle: "#E6F4FB",
  secondaryBorder: "#B3DCF0",

  // ─── Surfaces ──────────────────────────────────────────────────────────────
  white: "#FFFFFF",
  bgPage: "#F4F6F8",
  bgAlt: "#F8FAFC",
  bgHover: "#F0F2F4",

  // ─── Text ──────────────────────────────────────────────────────────────────
  textPrimary: "#0B1F41",
  textSecondary: "#403F55",
  textMuted: "#7A95AD",
  textLight: "#B8CCDA",
  textWhite: "#FFFFFF",

  // ─── Borders ───────────────────────────────────────────────────────────────
  borderLight: "#DDE6EE",
  borderDefault: "#B8CEDD",

  // ─── Shadows ───────────────────────────────────────────────────────────────
  shadowSm: "rgba(0, 0, 0, 0.08)",
  shadowMd: "rgba(0, 0, 0, 0.15)",
  shadowLg: "rgba(0, 0, 0, 0.25)",
  shadowDark: "rgba(0, 0, 0, 0.65)",

  // ─── Status: Success ───────────────────────────────────────────────────────
  success: "#22C55E",
  successDark: "#16A34A",
  successBg: "#F0FDF4",
  successBorder: "#BBF7D0",

  // ─── Status: Warning ───────────────────────────────────────────────────────
  warning: "#F59E0B",
  warningDark: "#D97706",
  warningBg: "#FFFBEB",

  // ─── Status: Error ─────────────────────────────────────────────────────────
  error: "#EF4444",
  errorDark: "#DC2626",
  errorBg: "#FEF2F2",

  // ─── Status: Info ──────────────────────────────────────────────────────────
  info: "#0E89C5",
  infoBg: "#E6F4FB",

  // ─── Accent (orange — prices, luggage, special CTAs) ───────────────────────
  accent: "#FC8D3D",
  accentDark: "#E07020",

  // ─── Inputs ────────────────────────────────────────────────────────────────
  inputLabel: "#7A95AD",

  // ─── Footer ────────────────────────────────────────────────────────────────
  footerBg: "#0B1F41",

  // ─── Buttons ───────────────────────────────────────────────────────────────
  searchButtonBg: "#ED1B23",
  hoverButtonBg: "#CF1C2A",
  removeRouteButtonBg: "#EF4444",

  // ─── Accent bg (light orange surface) ─────────────────────────────────────
  accentBg: "#FFF4EC",
  accentBorder: "#FDBA74",

  // ─── Transparencies ────────────────────────────────────────────────────────
  whiteAlpha20: "rgba(255, 255, 255, 0.20)",
  whiteAlpha80: "rgba(255, 255, 255, 0.80)",

  // ─── Special gradient (BalanceRecharge hero) ───────────────────────────────
  gradientStart: "#ED1B23",
  gradientMid: "#FF3344",
  gradientEnd: "#CF1C2A",
  gradientShadow: "rgba(237, 27, 35, 0.35)",

  // ─── Search hero background (dark navy — dushanbe24.ru) ────────────────────
  searchBg: "#0B1F41",
  searchBgMid: "#122742",
  searchBgLight: "#1A3556",
  searchOverlay: "rgba(11, 31, 65, 0.70)",
  searchOverlayMid: "rgba(18, 39, 66, 0.60)",
  searchOverlayLight: "rgba(26, 53, 86, 0.70)",

  // ─── Order status badge colors ─────────────────────────────────────────────
  orderStatus: {
    initial: "#7F1D1D",
    paySuccess: "#F59E0B",
    bookingDone: "#D97706",
    inProgressBook: "#D97706",
    ticketingDone: "#22C55E",
    certificateIssued: "#22C55E",
    ticketingFail: "#D97706",
    exchange: "#FFFBEB",
    void: "#5B21B6",
    orderFail: "#D97706",
    bookingFail: "#D97706",
    payFail: "#D97706",
    bookingCancelFromClient: "#DC2626",
    bookingCancelFromAdmin: "#DC2626",
    bookingCancelError: "#D97706",
    applicationRefund: "#BAE6FD",
    partialRefund: "#0E89C5",
    bookingCancel: "#DC2626",
    refund: "#0E89C5",
    balancePaymentRequest: "#ED1B23",
    balancePaymentApproved: "#16A34A",
  },

  // ─── Header ────────────────────────────────────────────────────────────────
  header: {
    background: "#FFFFFF",
    text: "#0B1F41",
    textMuted: "#403F55",
    textSecondary: "#7A95AD",
    hoverBg: "#F0F2F4",

    primary: "#ED1B23",
    primaryDark: "#CF1C2A",
    primaryShadowHover: "rgba(237, 27, 35, 0.25)",

    success: "#22C55E",
    danger: "#EF4444",
    dangerDark: "#DC2626",

    border: "rgba(237, 27, 35, 0.08)",
    shadow: "rgba(237, 27, 35, 0.10)",

    avatarGradientStart: "#ED1B23",
    avatarGradientEnd: "#CF1C2A",
    avatarShadowHover: "rgba(237, 27, 35, 0.30)",

    dropdownBg: "#FFFFFF",
    dropdownBorder: "rgba(237, 27, 35, 0.08)",
    dropdownShadow: "rgba(237, 27, 35, 0.15)",
    dropdownDivider: "#F0F2F4",
    dropdownItemText: "#0B1F41",
  },

  // Input/Form colors (формы заявки на возврат и поддержки, FileInput, Textarea)
  input: {
    border: "#ccc",
    borderFocus: "#0052ff",
    borderError: "#e53935",
    borderSuccess: "#8cd64e",
    errorText: "#e53935",
    errorBg: "rgba(229, 57, 53, 0.03)",
    focusShadow: "rgba(0, 82, 255, 0.1)",
    errorShadow: "rgba(229, 57, 53, 0.1)",
    labelText: "#75787b",
  },
};

export default palette;
